import { render, staticRenderFns } from "./PhilHealth.vue?vue&type=template&id=50b3155c&scoped=true"
import script from "./PhilHealth.vue?vue&type=script&lang=js"
export * from "./PhilHealth.vue?vue&type=script&lang=js"
import style0 from "./PhilHealth.vue?vue&type=style&index=0&id=50b3155c&prod&lang=css&scoped=true"
import style1 from "./PhilHealth.vue?vue&type=style&index=1&id=50b3155c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3155c",
  null
  
)

export default component.exports